app.RatingCommentHistoryModal = (function () {
    // Tracks whether the user has started typing a comment
    var commentsStarted = false;
    // Temporarily disables the close warning when necessary
    var bypassWarning = true;
    var remberedBypassWarning = false;

    var modal = {
        Init: function () {
            // Run initial setup, including setting up dropdown behavior
            app.RatingCommentHistoryModal.SetCommentType();

            // When new dropdowns are dynamically added, reinitialize comment type handling
            $(document).on('component-bind-edit-mode-complete-Comments', function () {
                app.RatingCommentHistoryModal.SetCommentType();
            });
            $(document).on('component-bind-view-mode-complete-ReviewMatrix', function () {
                app.RatingCommentHistoryModal.DimmerSwitch();
            });

            // Handles opening the rating/comment history modal
            // Supports both click and keyboard interaction (Enter/Space)
            $(document).on("click keydown", "[data-rating-comment-history]", function (e) {
                if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) {
                    return;
                }
                app.RatingCommentHistoryModal.DimmerSwitch();

                var appId = $(this).data("rating-comment-history-application-id");
                var userId = $(this).data("rating-comment-history-user-id");
                var url = $(this).data("rating-comment-history-url");
                var modalTarget = $(this).data("modal-body-target");
                var modalBody = $("[data-modal-body='" + modalTarget + "']");
                var modalId = $(this).data("open");

                // Show loading indicator while fetching data
                $(modalBody).html('<div class="text-center"><img src="/Content/Images/Icons/loading.gif" /></div>');
                $("#" + modalId).modal("show");

                // Fetch comment history via AJAX request
                $.ajax({
                    type: "POST",
                    url: url,
                    data: { applicationId: appId, userId: userId },
                    success: function (data) {
                        // Load the comment history content
                        $(modalBody).html(data);
                    },
                    error: function () {
                        $("#" + modalId).modal("hide");
                        toastr.error("An error occurred accessing your rating/comment history. Please try again.");
                    }
                });
            });

            // Handles opening the "All Rating Comment History" modal
            // Same keyboard accessibility support as above (Enter/Space)
            $(document).on("click keydown", "[data-all-rating-comment-history]", function (e) {
                if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) {
                    return;
                }
                app.RatingCommentHistoryModal.DimmerSwitch();

                var applicantId = $(this).data("all-rating-comment-history-applicant-id");
                var currentApplicationId = $(this).data("all-rating-comment-history-application-id");
                var url = $(this).data("all-rating-comment-history-url");
                var modalTarget = $(this).data("modal-body-target");
                var modalBody = $("[data-modal-body='" + modalTarget + "']");
                var modalId = $(this).data("open");

                // Reset modal content and show loading indicator
                $(modalBody).html(null);
                $(modalBody).html('<div class="text-center"><img src="/Content/Images/Icons/loading.gif" /></div>');
                $("#" + modalId).modal("show");

                // Fetch all comments history via AJAX
                $.ajax({
                    type: "POST",
                    url: url,
                    data: { applicantId: applicantId, currentApplicationId: currentApplicationId },
                    success: function (data) {
                        // Load the content
                        $(modalBody).html(data);
                    },
                    error: function () {
                        $("#" + modalId).modal("hide");
                        toastr.error("An error occurred accessing comment history. Please try again.");
                    }
                });
            });

            app.RatingCommentHistoryModal.Modal();
        },

        // Handles comment type dropdown interactions
        SetCommentType: function () {
            $("select[name='SelectedCommentType']").on("change", function () {
                app.RatingCommentHistoryModal.HandleCommentTypeChange(this);
            });
            // Allow certain buttons to close the modal without triggering the warning
            // Track if a user starts typing in a comment field
            $("#applicant-comments button[data-component-role='RemoveButton'], " +
                "#applicant-comments button[data-component-role='CancelButton'], " +
                "#applicant-comments button[data-component-role='SaveButton']").on("click keydown", function () {
                    bypassWarning = true;
                });
        },

        // Handles the modal interactions for applicant comments
        Modal: function () {
            $(document).on('bind-comments-modal', function () {
                $("button[data-application-id]").off("click keyup").on("click keyup", function () {
                    var button = $(this);
                    var applicationId = button.data("application-id");

                    var $employerCommentsDiv = $("div[data-component-type='EmployerComments']");

                    // Set the application ID for the comments section
                    $employerCommentsDiv
                        .data("component-id", applicationId)
                        .attr("data-component-id", applicationId);

                    // Load the employer comments into the view
                    app.page.components["EmployerComments"][0].startViewMode(true, { id: applicationId });

                    $("#applicant-comments").modal();
                });
            });

            // Track if a user starts typing in a comment field
            $(document).on("input", "textarea[name='Comment']", function () {
                commentsStarted = true;
                bypassWarning = false;
            })

            // Prevent modal from closing if user started typing
            $("#applicant-comments").on("hide.bs.modal", function (event) {
                if (commentsStarted && !bypassWarning) {
                    if (!window.confirm("Any unsaved comments may be lost. Are you sure you want to leave?")) {
                        // Stop modal from closing
                        event.preventDefault();
                    }
                }
                commentsStarted = false;
                bypassWarning = true;
            });
        },

        // Temporarily hides one modal and restores it after the second modal closes
        DimmerSwitch: function () {
            const modal = $("#allRatingCommentHistory");
            const rmModals = $(".reviewMatrixGrid");
            const applicantComments = $("#applicant-comments");

            modal.on("show.bs.modal", function () {
                // Avoid close warning when hiding
                remberedBypassWarning = bypassWarning;
                if (commentsStarted) {
                    bypassWarning = true;
                }
                applicantComments.modal("hide");
            });

            modal.on("hidden.bs.modal", function () {
                bypassWarning = remberedBypassWarning;
                remberedBypassWarning = false;
                applicantComments.modal("show");
            });

            if (rmModals.length > 0) {

                for (var i = 0; i < rmModals.length; i++) {
                    var id = "#" + rmModals[i].id;
;                    modal.on("show.bs.modal", function () {
                        // Avoid close warning when hiding
                        remberedBypassWarning = bypassWarning;
                        if (commentsStarted) {
                            bypassWarning = true;
                        }
                        $(id).modal("hide");
                    });

                    modal.on("hidden.bs.modal", function () {
                        bypassWarning = remberedBypassWarning;
                        remberedBypassWarning = false;
                        $(id).modal("show");
                    });
                }
            }
        },

        // Handles logic for changing comment type dropdown
        HandleCommentTypeChange: function (dropdown) {

            const form = $(dropdown).closest("form");
            const affiliationDiv = $(form).find(".affiliationDiv");
            const commentDiv = $(form).find(".commentDiv");
            const selectedOption = $(dropdown).find(":selected");
            const typeId = $(selectedOption).val();

            // Always show commentDiv when creating a new comment
            const commentId = $(form).find("input[name='Id']").val();
            if (!commentId || commentId === "0") {
                $(commentDiv).show();
            }

            // Show or hide affiliationDiv based on the selected comment type
            if (typeId === "district-comment") {
                $(affiliationDiv).show();
            } else {
                $(affiliationDiv).hide();
            }

            // If "application-comment" is selected, clear all checkboxes in affiliationDiv
            if (typeId === "application-comment") {
                $(affiliationDiv).find("input[type='checkbox']").prop("checked", false);
            }
        }
    };

    return modal;
})();